/**
 * Given a row of data and an index, extracts the data at that index. If a null
 * value is passed for the index, returns null. Converts numbers to numbers,
 * including stripping formatting marks like commas. Converts hyphens to nulls.
 * @param {Array} row - The row of data to examine.
 * @param {number|undefined} index - The index of data to look up, or undefined
 *    if the index wasn't found in the map.
 * @returns {string|number|null} - The value of the cell. A string if it is a
 *    string, a number if it is a number, or null if no value or a hyphen.
 */
const getCellValue = (row, index) => {
  // Return null if the requested index is null or out of bounds.
  if (index === undefined || index >= row.length) {
    return null;
  }

  // Get the raw value and process it.
  const value = row[index].trim();

  // Handle hyphens and empty values.
  if (value === '-' || value === '') {
    return null;
  }

  // Handle numbers.
  if (value.match(/^[0-9,.]+$/)) {
    const decommatized = value.replaceAll(',', '');
    return value.includes('.') ? parseFloat(decommatized) : parseInt(decommatized, 10);
  }

  return value;
};

export default getCellValue;
